import type {
  ActivityType,
  InsulinActivity,
  DeepPartial,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  useCallback,
  useEffect,
  useRef,
} from "react"
import type { DeepReadonlyObject } from "rxdb"

import type {
  AccountInsulin,
  EditableSubEntry,
} from "src/types"

export function useOnCurrentAccountInsulinDeleted(
  activity: DeepPartial<InsulinActivity> | undefined,
  updateActivity: (a: DeepPartial<InsulinActivity>) => void,
  currentAccountInsulin: DeepReadonlyObject<AccountInsulin> | undefined,
  currentSubEntry: EditableSubEntry<ActivityType.Insulin>,
) {
  const previousAccountInsulinRef = useRef<DeepReadonlyObject<AccountInsulin> | undefined>(currentAccountInsulin)

  // reset the activity if it is a new activity and its account insulin is removed
  const resetIfUnsaved = useCallback(
    () => {
      if (!currentSubEntry._id) {
        updateActivity({
          insulin_med: undefined,
        })
      }
    },
    [
      updateActivity,
      currentSubEntry._id,
    ],
  )

  useEffect(
    () => {
      if (
        !currentAccountInsulin &&
        !!previousAccountInsulinRef.current &&
        previousAccountInsulinRef.current.id === `${activity?.insulin_med?.account_insulin_id}`
      ) {
        resetIfUnsaved()
      }

      previousAccountInsulinRef.current = currentAccountInsulin
    },
    [
      activity,
      resetIfUnsaved,
      currentAccountInsulin,
      previousAccountInsulinRef,
    ],
  )
}
